import transitionPage from "@/components/transitionPage/index";
import suggestionApps from "@/components/suggestionApps/index";
import Language from "@/components/appbar/Language";
// import $lang from "@/mixins/lang";

export default {
  name: "auth",
  components: { transitionPage, suggestionApps, Language },
  props: [],
  mixins: [],
  data() {
    return {
      publicUrl: process.env.VUE_APP_PUBLIC_BASE_URL
    };
  },
  computed: {},
  methods: {
    changeTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem("isDark", this.$vuetify.theme.dark);
    }
    // switchLangFunc() {
    //   if (this.$i18n.locale === "fa") {
    //     this.$vuetify.rtl = false;
    //     this.$i18n.locale = "en";
    //     localStorage.setItem("lang", this.$i18n.locale);
    //     localStorage.setItem("direction", "ltr");
    //   } else {
    //     this.$vuetify.rtl = true;
    //     this.$i18n.locale = "fa";
    //     localStorage.setItem("lang", this.$i18n.locale);
    //     localStorage.setItem("direction", "rtl");
    //   }
    //
    //   this.$router.push({
    //     query: Object.assign({}, this.$route.query, {
    //       lang: this.$i18n.locale
    //     })
    //   });
    // }
  }
};
